<div class="np-scrollable h-100">
  <dx-data-grid
      id="gridMediaPoolContainer"
      class="h-100"
      [dataSource]="dataSource"
      [allowColumnReordering]="true"
      [rowAlternationEnabled]="true"
      [allowColumnResizing]="true"
      noDataText="{{ 'Keine Medien vorhanden' | translate }}"
      [showBorders]="true"
      (onRowPrepared)="onRowPrepared($event)"
  >
    <dxo-search-panel
        [visible]="true"
        placeholder="{{ 'Suchen' | translate }}"
        [highlightCaseSensitive]="false"
    ></dxo-search-panel>

    <dxo-toolbar>
      <dxi-item name="searchPanel" location="before"></dxi-item>
    </dxo-toolbar>

    <dxo-remote-operations [sorting]="true" [paging]="true" [filtering]="true"></dxo-remote-operations>
    <dxo-paging [pageSize]="50"></dxo-paging>
    <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[50, 100]"></dxo-pager>

    <dxo-state-storing
        [enabled]="true"
        type="localStorage"
        storageKey="MediaPoolStateNewUIV3"
    ></dxo-state-storing>

    <dxi-column
        dataField="normUri"
        caption=""
        [width]="60"
        [allowFiltering]="false"
        [allowSorting]="false"
        cellTemplate="imageCellTemplate"
    ></dxi-column>

    <div *dxTemplate="let data of 'imageCellTemplate'" style="overflow: visible">
      <div (mouseenter)="showImage(data.value, data.rowIndex)" (mouseleave)="hideImage()">
        <span *ngIf="!data.value" class="glyphicon glyphicon-picture" style="font-size: 40px"></span>
        <img
            *ngIf="data.value"
            src="{{ data.value }}{{ mimedate() }}"
            style="height: 40px"
            id="link{{ data.rowIndex }}"
        />
      </div>
    </div>

    <dxi-column
        dataField="mimeSource"
        caption="{{ 'Dateiname' | translate }}"
        cellTemplate="nameCellTemplate"
    ></dxi-column>

    <div *dxTemplate="let data of 'nameCellTemplate'">
      <a
          href="{{ data.data.blobUri }}{{ getEncodedString(data.data.mimeSource) }}{{ mimedate() }}"
          target="_blank"
          rel="noopener"
      >
        {{ data.value }}
      </a>
    </div>

    <dxi-column
        dataField="fileSize"
        [allowFiltering]="false"
        [allowSorting]="false"
        caption="{{ 'Größe' | translate }}"
        cellTemplate="sizeCellTemplate"
    ></dxi-column>

    <div *dxTemplate="let data of 'sizeCellTemplate'">
      {{ getFileSizeString(data.value) }}
    </div>

    <dxi-column [width]="100" cellTemplate="editCellTemplate"></dxi-column>

    <div *dxTemplate="let data of 'editCellTemplate'">
      <div *ngIf="canView('mimePool')">
        <dx-button
            [disabled]="readOnlyUser('mimeReplace')"
            (onClick)="replaceMime(data)"
            icon="glyphicon glyphicon-random"
            stylingMode="text"
            hint="{{ 'Mime Datei ersetzen' | translate }}"
        />
        <dx-button
            [disabled]="readOnlyUser('mimeDelete')"
            (onClick)="deleteRequest(data)"
            icon="trash"
            stylingMode="text"
            hint="{{ 'Mime Datei löschen' | translate }}"
        />
      </div>
    </div>
  </dx-data-grid>
</div>

<!-- Footer: Buttons -->
<footer class="np-footer" style="justify-content: center">
  <dx-button
      *ngIf="!readOnlyUser('mediaPool')"
      text="{{ 'Importieren' | translate }}"
      hint="{{ 'Medien importieren' | translate }}"
      (onClick)="showImportMedia()"
      stylingMode="outlined"
      type="default"
  ></dx-button>

  <dx-button
      *ngIf="!readOnlyUser('mediaPool')"
      text="{{ 'Download' | translate }}"
      hint="{{ 'Alle Medien als ZIP herunterladen' | translate }}"
      (onClick)="downloadMimes()"
      stylingMode="outlined"
      type="default"
  ></dx-button>

  <dx-button
      stylingMode="outlined"
      type="default"
      icon="refresh"
      hint="{{ 'Aktualisieren' | translate }}"
      (onClick)="reload()"
  ></dx-button>
</footer>

<dx-popover
    [(target)]="target"
    position="bottom"
    [width]="300"
    [showTitle]="false"
    [(visible)]="imageVisable"
>
  <div *dxTemplate="let data = model of 'content'">
    <img src="{{ source }}{{ mimedate() }}" style="height: 244px;"/>
  </div>
</dx-popover>

<dx-popup
    class="popup"
    [width]="500"
    [height]="300"
    [showTitle]="true"
    title="{{ 'Datei importieren' | translate }}"
    [dragEnabled]="false"
    [hideOnOutsideClick]="true"
    [(visible)]="importFileVisible"
    contentTemplate="popupContent"
>
  <div *dxTemplate="let data of 'popupContent'">
    <importFile (uploaded)="onImportFileUploaded()"></importFile>
  </div>
</dx-popup>

<dx-popup
    [width]="800"
    [height]="450"
    [showTitle]="true"
    title="{{ 'Medien importieren' | translate }}"
    [dragEnabled]="false"
    [hideOnOutsideClick]="true"
    [showCloseButton]="true"
    [(visible)]="importMediaVisible"
    contentTemplate="popupContent"
>
  <div *dxTemplate="let data of 'popupContent'">
    <importMedia (onImportMedia)="hideImportMedia()"></importMedia>
  </div>
</dx-popup>
